import React, { useContext, useRef, useState } from "react";
import Input from "../../../elements/Input";
import Button from "../../../elements/Button";
import { DatePicker } from "react-advance-jalaali-datepicker";
import Select from "../../../elements/Select/Select";
import { CITIES } from "../../../constant/Cities";
import { API_LINKS } from "../../../constant/Links";
import { request } from "../../../utils/HttpRequest";
import { ROUTES } from "../../../constant/Routes";
import { LoadingContext } from "../../../context/Loading/LoadingContext";
import { useNavigate } from "react-router";
import { AiOutlineUserAdd } from "react-icons/ai";

const DatePickerInput = (props) => {
  return (
    <Input
      isDate="date"
      placeHolder="تاریخ انقضا پروانه"
      padding="p-3"
      {...props}
    />
  );
};

const signupRequest = (formData, navigate, loadingContext) => {
  loadingContext.startLoading();
  request(
    API_LINKS.BASE + API_LINKS.LABORATORY.SIGNUP,
    formData,
    (res) => {
      signSuccess(res, navigate, loadingContext);
    },
    (error) => {
      signFailed(loadingContext);
    }
  );
};

const signSuccess = (res, navigate, loadingContext) => {
  loadingContext.endLoading();
  if (res.status) {
    alert("آزمایشگاه ری گیری با موفقیت افزوده شد");
    navigate(ROUTES.LOGIN);
  } else {
    alert(res.msg);
  }
};

const signFailed = (loadingContext) => {
  loadingContext.endLoading();
  alert("اشکال در برقراری ارتباط با سرور");
};

const Signup = (props) => {
  const [validate, setValidate] = useState(0);

  const loadingContext = useContext(LoadingContext);

  const navigate = useNavigate();

  const [date, setDate] = useState(
    new Intl.DateTimeFormat("fa-IR").format(new Date())
  );

  const nameRef = useRef(null);
  const codeRef = useRef(null);
  const cityRef = useRef(null);
  const ownerNameRef = useRef(null);
  const mobileRef = useRef(null);
  const nationalCodeRef = useRef(null);
  const phoneRef = useRef(null);
  const passRef = useRef(null);
  const rePassRef = useRef(null);

  const changeDateHandle = (unix, format) => {
    setDate(format);
  };

  const submitHandle = (setValidate) => {
    const name = nameRef.current.value;
    const code = codeRef.current.value;
    const city = cityRef.current.value;
    const ownerName = ownerNameRef.current.value;
    const mobile = mobileRef.current.value;
    const nationalCode = nationalCodeRef.current.value;
    const phone = phoneRef.current.value;
    const pass = passRef.current.value;
    const rePass = rePassRef.current.value;

    if (name.length < 3) {
      setValidate(1);
      nameRef.current.focus()
      return;
    }

    if (isNaN(parseInt(code))) {
      setValidate(2);
      codeRef.current.focus()
      return;
    }

    if (ownerName.length < 3) {
      setValidate(3);
      ownerNameRef.current.focus()
      return;
    }

    if (
      mobile.length !== 11 ||
      mobile[0] + mobile[1] !== "09" ||
      isNaN(parseInt(mobile))
    ) {
      setValidate(4);
      mobileRef.current.focus()
      return;
    }

    if (nationalCode.length !== 10 || isNaN(parseInt(nationalCode))) {
      setValidate(5);
      nationalCodeRef.current.focus()
      return;
    }

    if (phone.length < 8 || isNaN(parseInt(phone))) {
      setValidate(6);
      phoneRef.current.focus()
      return;
    }

    if (pass !== rePass || pass.length < 4) {
      setValidate(7);
      passRef.current.focus()
      return;
    }
    setValidate(0);

    const obj = {
      name: name,
      businessLicenseCode: code,
      cityId: city,
      ownerName: ownerName,
      mobile: mobile,
      nationalCode: nationalCode,
      telephone: phone,
      password: pass,
      businessLicenseExpirationDate: date,
    };

    signupRequest(obj, navigate, loadingContext);
  };

  return (
    <section className=" ">
      <div className="grid min-h-[calc(100vh-128px)] max-h-[calc(100vh-256px)] overflow-auto place-items-center">
        <div className="bg-lightSecondary dark:bg-darkSecondary rounded-2xl  shadow-2xl p-4 m-5 w-11/12 sm:w-fit">
          <h1 className="text-center text-2xl mb-4 dark:text-darkTextPrimary text-lightTextPrimary">
            ثبت نام
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-3">
            <div className="sm:col-span-3">
              <Input
                extraClass="rounded-2xl"
                type="text"
                placeHolder="نام آزمایشگاه"
                padding="p-3"
                refrence={nameRef}
                mode={validate == 1 ? "error" : "normal"}
                message={
                  validate == 1
                    ? "لطفا نام آزمایشگاه را به درستی وارد کنید"
                    : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div className="">
              <Input
                extraClass="rounded-2xl"
                type="text"
                placeHolder="کد پروانه کسب"
                inputMode="numeric"
                refrence={codeRef}
                padding="p-3"
                mode={validate == 2 ? "error" : "normal"}
                message={
                  validate == 2
                    ? "لطفا کد پروانه کسب را به درستی وارد کنید"
                    : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div className="datePicker z-20">
              <DatePicker
                inputComponent={DatePickerInput}
                format="YYYY/MM/DD"
                preSelected={date}
                onChange={changeDateHandle}
                id="datePicker"
                cancelOnBackgroundClick={true}
                controlValue={true}
              />
            </div>
            <div>
              <Select
                extraClass="rounded-2xl"
                refrence={cityRef}
                options={CITIES}
                placeHolder="شهر"
                padding="p-3"
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="text"
                refrence={ownerNameRef}
                placeHolder="نام مالک"
                padding="p-3"
                mode={validate == 3 ? "error" : "normal"}
                message={
                  validate == 3 ? "لطفا نام مالک را به درستی وارد کنید" : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="text"
                refrence={mobileRef}
                placeHolder="موبایل مالک"
                inputMode="numeric"
                maxLength="11"
                padding="p-3"
                mode={validate == 4 ? "error" : "normal"}
                message={
                  validate == 4 ? "لطفا موبایل مالک را به درستی وارد کنید" : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="text"
                placeHolder="کدملی"
                inputMode="numeric"
                refrence={nationalCodeRef}
                padding="p-3"
                mode={validate == 5 ? "error" : "normal"}
                message={
                  validate == 5 ? "لطفا کدملی را به درستی وارد کنید" : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="text"
                refrence={phoneRef}
                placeHolder="تلفن آزمایشگاه"
                inputMode="numeric"
                padding="p-3"
                mode={validate == 6 ? "error" : "normal"}
                message={validate == 6 ? "لطفا تلفن را به درستی وارد کنید" : ""}
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="password"
                refrence={passRef}
                placeHolder="رمزعبور"
                padding="p-3"
                mode={validate == 7 ? "error" : "normal"}
                message={
                  validate == 7
                    ? "لطفا رمزعبور و تکرار آن را به درستی وارد کنید"
                    : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div>
              <Input
                extraClass="rounded-2xl"
                type="password"
                refrence={rePassRef}
                placeHolder="تکرار رمزعبور"
                padding="p-3"
                mode={validate == 7 ? "error" : "normal"}
                message={
                  validate == 7
                    ? "لطفا رمزعبور و تکرار آن را به درستی وارد کنید"
                    : ""
                }
                handler={() => {
                  setValidate(0);
                }}
              />
            </div>
            <div className="text-center sm:col-span-3">
              <Button
                extraClass="text-darkTextPrimary my-4"
                padding="py-3 px-10"
                icon={<AiOutlineUserAdd className="text-xl" />}
                type="submit"
                variant="success"
                content="ثبت نام"
                rounded="rounded-2xl"
                onClick={() => {
                  submitHandle(setValidate);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Signup;
